/**
 * Safely check if window object is available
 * Prevents SSR errors and ensures safe access to browser APIs
 */
export const isSafeToUseWindow = () => {
  return typeof window !== "undefined";
};

/**
 * Get window width safely
 */
export const getWindowWidth = () => {
  if (!isSafeToUseWindow()) return 1024; // Default desktop width
  return window.innerWidth;
};

/**
 * Check if device is mobile based on window width
 */
export const checkIsMobile = () => {
  return getWindowWidth() <= 768;
};

/**
 * Safely access localStorage
 */
export const safeLocalStorage = {
  getItem: (key) => {
    if (!isSafeToUseWindow()) return null;
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error("localStorage access error:", error);
      return null;
    }
  },
  setItem: (key, value) => {
    if (!isSafeToUseWindow()) return;
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error("localStorage write error:", error);
    }
  },
};

/**
 * Check if user agent is mobile
 */
export const isMobileUserAgent = () => {
  if (!isSafeToUseWindow()) return false;
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};
